import { Button } from '~/components/ui/Button';
import { IconButton } from '~/components/ui/IconButton';
import { useClearUpdateTeamData } from '~/lib/hooks/useClearUpdateTeamData';

interface FallbackProps {
  showPricingOverlay: VoidFunction;
}

export const Fallback = ({ showPricingOverlay }: FallbackProps) => {
  const clearUpdateTeamData = useClearUpdateTeamData();

  const goBack = () => {
    clearUpdateTeamData();
  };

  return (
    <div className="flex gap-1 items-center pt-6 pl-6 pr-12 text-sm text-bolt-ds-textPrimary">
      <IconButton icon="i-heroicons:arrow-left-solid" size="md" variant="ghost" onClick={goBack} />
      To manage members access, you'll need an active subscription.{' '}
      <Button variant="link-gray" onClick={showPricingOverlay} className="text-bolt-ds-textPrimary underline">
        Select your pricing plan.
      </Button>
    </div>
  );
};
